/** Случаи вопроса клиента: цитата, канал, ответили ли, ссылка в диалог. `cards` — строка «Карточка: …».
 * Что ответил сотрудник в диалоге, сервер отдаёт только редактору — сотрудник видит слова клиента и
 * отвечает сам. Показываем по `step` случаев, дальше — «Показать ещё». */
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { Link } from "react-router";

import { ApiFailure } from "@/lib/api";
import { channelName, loadHits, periodText } from "@/lib/knowledge";

export function Hits({ id, days, cards = true, step = 10 }: { id: number; days: number; cards?: boolean; step?: number }) {
  const q = useQuery({ queryKey: ["kb", "hits", id, days], queryFn: () => loadHits(id, days) });
  const [shown, setShown] = useState(step);
  if (!q.data) return <div className="py-2 text-[12px] text-fg-muted">{q.error ? (q.error instanceof ApiFailure ? q.error.message : "Ошибка") : "Загрузка…"}</div>;
  const hits = q.data.hits;
  return (
    <div className="mt-2 space-y-2 border-l-2 border-border pl-3">
      {cards && q.data.cards.length > 0 && (
        <div className="text-[12px] text-fg-muted">
          Карточка:{" "}
          {q.data.cards.map((c) => (
            <Link key={c.id} to={`/knowledge/${c.id}`} className="mr-2 text-fg underline">
              {c.title}
            </Link>
          ))}
        </div>
      )}
      {hits.length === 0 && <div className="text-[12px] text-fg-muted">Диалогов с этим вопросом {periodText(days)} нет.</div>}
      {hits.slice(0, shown).map((h) => (
        <div key={h.id} className="text-[12.5px]">
          <div className="flex flex-wrap gap-x-2 text-[11.5px] text-fg-faint">
            <span>{h.date}</span>
            <span>{channelName(h.channel)}</span>
            <span className={h.answered === "yes" ? "text-ok" : h.answered === "partial" ? "text-warn" : "text-err"}>
              {h.answered === "yes" ? "ответили" : h.answered === "partial" ? "частично" : "без ответа"}
              {h.answered !== "no" && !h.verified ? " · роль не подтверждена" : ""}
            </span>
            <Link to={h.source === "chat" ? `/chats/${h.source_id}${h.message_id ? `?msg=${h.message_id}` : ""}` : `/calls/${h.source_id}`} className="underline">
              {h.source === "chat" ? "открыть чат" : "открыть звонок"}
            </Link>
          </div>
          <div className="text-fg">«{h.quote}»</div>
          {h.evidence ? <div className="text-fg-muted">→ «{h.evidence}»</div> : h.answer ? <div className="text-fg-muted">→ пересказ: {h.answer}</div> : null}
        </div>
      ))}
      {hits.length > shown && (
        <button type="button" className="text-[12px] text-fg-muted underline hover:text-fg" onClick={() => setShown(shown + step * 3)}>
          Показать ещё · {hits.length - shown}
        </button>
      )}
    </div>
  );
}
